import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { addFlashMessageOfType } from 'redux-flash-messages'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as maintenanceActions } from '../../../actions/maintenance'
import styled from 'styled-components'
import Moment from 'moment';
import GenericModal from '../../GenericModal'
import employeeService from '../../../services/Employee.service'
import InfoIcon from "../../../images/info.svg";
import Tooltip from '../../Tooltip';
import classNames from 'classnames';

const StyledInfoIcon = styled.img`
  width: 15px;
  float: right;
  margin-left: 5px;

  :hover {
    cursor: pointer;
  }
`

const Content = styled.div`
  padding: 15px 20px 15px 20px;

  .tooltip-button {
    border: 0;
    background: none;
    padding: 0;
    width: 15px;
    height: 15px;
    margin-left: 5px;
  }

  .info-tooltip {
    font-weight: normal;
    text-align: left;
    line-height: normal;

    dl {
      margin: 5px;
    }
    dt {
      float: left;
      clear: left;
      width: 90px;
      text-align: right;
      font-weight: bold;
    }
    dt::after {
      content: ":";
    }
    dd {
      margin: 0 0 0 100px;
      padding: 0 0 0.5em 0;
    }
  }

  > div {
    font-family: Lato-Regular;
    font-size: 14px;

    line-height: 22px;
    color: #2B2B2B;
    margin: 0px;
    margin-bottom: 0px;
    height: 100%;

    #header-row {
      width: calc(100% - 43px);
      padding: 0px 15px 0px;
      display: flex;
      font-weight: bold;

      .header-award-column {
        width: 35%;
      }

      .header-selected-election-container {
        width: 45%;
        margin: auto;
      }

      .header-selected-election {
        display: inline-block;
        float: left;
        margin-right: 15px;
      }

      .header-effective-election-container {
        width: 20%;
        margin: auto;
      }

      .header-effective-election {
        display: inline-block;
      }
    }

    #vest-rows {
      height: calc(100% - 175px);
      overflow-y: scroll;
      overflow-x: hidden;
      border: 1px solid #DDDDDD;

      .disabled {
        background-color: lightgray;
      }

      .vest-row {
        width: calc(100% - 30px);
        border: 1px solid #DDDDDD;
        padding: 0px 15px 0px;
        display: flex;

        .award-info-container {
          width: 35%;

          .vest-date-container {
            font-weight: bold;
            margin: auto;

            .vest-date {
              display: inline-block;
              margin-right: 20px;
            }

            .shares {
              display: inline-block;
            }
          }

          .award-id-container {
            margin: auto;

            .award-id {
              display: inline-block;
              margin-right: 20px;
            }

            .award-name {
              display: inline-block;
            }
          }
        }

        .selected-election-container {
          width: 45%;
          margin: auto;

          .cash-refund-container {
            display: inline-block;
            float: left;
            margin-right: 15px;

            .cash-refund-radio {
              margin-left: 5px;
              position: relative;
              top: 1px;
            }
          }

          .fractional-shares-container {
            display: inline-block;
            float: left;

            .fractional-shares-radio {
              margin-left: 5px;
              position: relative;
              top: 1px;
            }
          }
        }

        .effective-election-container {
          width: 20%;
          margin: auto;
        }
      }
    }

    #future-awards {
      border: 1px solid #DDDDDD;

      #future-awards-row {
        width: calc(100% - 43px);
        padding: 0px 15px 0px;
        display: flex;

        .award-column {
          width: 35%;
        }

        .selected-election-container-future {
          width: 45%;
          margin: auto;

          .cash-refund-container-future {
            display: inline-block;
            float: left;
            margin-right: 15px;

            .cash-refund-radio-future {
              margin-left: 5px;
              position: relative;
              top: 1px;
            }
          }

          .fractional-shares-container-future {
            display: inline-block;
            float: left;

            .fractional-shares-radio-future {
              margin-left: 5px;
              position: relative;
              top: 1px;
            }
          }
        }

        .effective-election-container-future {
          width: 20%;
          margin: auto;
        }
      }
    }
  }
`

const Footer = styled.div`
  > button {
    height: 41px;
    width: 100%;
  }
`
class FractionalSharesDialog extends Component {
  constructor(props){
    super(props);

    let vests = []
    let employee = {}

    props.vests.every((vest, index) => {
      vests.push({
        id: vest.id,
        fractionalShareIndicator: vest.fractional_share_in,
        fractional_share_eligible_in: vest.fractional_share_eligible_in,
        vest_date: vest.vest_date,
        vest_shares: vest.vest_shares,
        award_id: vest.award_id,
        award_name: vest.award_name,
        tax_election: vest.tax_election
      })
      return true;
    })

    employee = {
      person_id: props.employee.id,
      fractional_share_in: props.employee.fractional_share_in
    }

    this.state = {
      vests: vests,
      employee: employee,
      infoTooltipHidden: true
    }
  }

  buttonClickHandler = (callback) => {
    let employee = this.state.employee
    let vests = this.state.vests

    // need to save the fractional shares information
    this.props.actions.employee.applyFractionalIndicators(employee, vests).then( _ => {
      addFlashMessageOfType("SUCCESS", 5000, this.props.t('FractionalSharesDialog.FractionalShareElectionsApplied'), null, null);
      this.props.onCloseDialog(callback)
    }).catch( _ => {
      console.log("There was an error applying elections")
      addFlashMessageOfType("ERROR", 5000, this.props.t('FractionalSharesDialog.FailedToApply'), null, null);
      this.resetAndClose(callback)
    })

  }

  fractionalInfoClickHandler = (callback) => {
    // display/hide the fractional election information box
    this.setState({
      infoTooltipHidden : !this.state.infoTooltipHidden
    });
  }

  infoTooltipBlurHandler = (callback) => {
    // hide the fractional election information box on blur
    this.setState({
      infoTooltipHidden : true
    });
  }

  resetVestsAndEmployee = () => {

    let vests = []
    let employee = {}

    this.props.vests.every((vest, index) => {
      vests.push({
        id: vest.id,
        fractionalShareIndicator: vest.fractional_share_in,
        fractional_share_eligible_in: vest.fractional_share_eligible_in,
        vest_date: vest.vest_date,
        vest_shares: vest.vest_shares,
        award_id: vest.award_id,
        award_name: vest.award_name,
        tax_election: vest.tax_election
      })
      return true;
    })

    employee = {
      person_id: this.props.employee.id,
      fractional_share_in: this.props.employee.fractional_share_in
    }

    this.setState({
      vests: vests,
      employee: employee
    })
  }

  resetAndClose = (callback) => {
    this.resetVestsAndEmployee()
    this.props.onCloseDialog(callback)
  }

  handleVestRadioChange = (event) => {
    const target = event.target
    const index = target.dataset.index
    var vests = this.state.vests
    vests[index].fractionalShareIndicator = target.value === true || target.value === "true" ? true : false

    this.setState({
      vests: vests
    })
  }

  handleEmployeeRadioChange = (event) => {
    const target = event.target
    var employee = this.state.employee
    employee.fractional_share_in = target.value === true || target.value === "true" ? true : false

    // set all vests as well
    var vests = this.state.vests
    vests.forEach(vest => {
      // only apply the change to vests that are eligible for changing fractional election
      if (vest.fractional_share_eligible_in) {
        vest.fractionalShareIndicator = target.value === true || target.value === "true" ? true : false
      }
    })

    this.setState({
      employee: employee,
      vests: vests
    })
  }

  getEffectiveElection = (vest) => {

    var award = employeeService.loadAwardWithVest(this.props.employee, vest.award_id, vest.id)

    if (vest.fractional_share_eligible_in) {
      if (vest.tax_election && vest.tax_election.code){
        if (vest.tax_election.code === "1" || vest.tax_election.code === "2"){
          return "* " + this.props.t(`TaxTreatment.${vest.tax_election.code}`)
        }
        else {
          return this.props.t(`TaxTreatment.${vest.tax_election.code}`)
        }
      }
      else {
        return ""
      }
    }
    else {
      return "** " + this.props.t('FractionalSharesDialog.NotApplicable')
    }
  }

  render() {
    const { t, employee, vests } = this.props

    var infoTooltipClasses = classNames({
        'hidden': this.state.infoTooltipHidden,
    });

    infoTooltipClasses = 'info-tooltip ' + infoTooltipClasses

    return (
      <GenericModal
        title={t('PopularActions.FractionalSharesButton')}
        visible={this.props.visible}
        onCloseDialog={this.resetAndClose}
        width={720}
        //height={600}
        className="fractional-shares-dialog"
      >
        <Content>
          <div>

            <div id="headers">
              <div id="header-row">
                <div className="header-award-column">
                  <div style={{fontWeight: "bold"}}>
                    {t('FractionalSharesDialog.HeaderVestingEvent')}
                  </div>
                </div>

                <div className="header-selected-election-container">
                  <div className="header-selected-election">
                    {t('FractionalSharesDialog.HeaderFractionalElection')}
                    <button className={"tooltip-button"} onBlur={this.infoTooltipBlurHandler} onClick={this.fractionalInfoClickHandler}><StyledInfoIcon alt={t('FractionalSharesDialog.HeaderFractionalElectionInfoIcon')} src={InfoIcon} /></button>
                    <Tooltip arrow="down" classes="info-tooltip" hidden={this.state.infoTooltipHidden}>
                      <dl>
                        <dt>{t('FractionalSharesDialog.HeaderCashRefund')}</dt>
                        <dd>{t('FractionalSharesDialog.HeaderCashRefundInfo')}</dd>
                        <dt>{t('FractionalSharesDialog.HeaderFractionalShares')}</dt>
                        <dd>{t('FractionalSharesDialog.HeaderFractionalSharesInfo')}</dd>
                      </dl>
                    </Tooltip>
                  </div>
                </div>

                <div className="header-effective-election-container">
                  <div className="header-effective-election">
                    {t('FractionalSharesDialog.HeaderTaxElection')}
                  </div>
                </div>
              </div>
            </div>

            <div id="future-awards">
              <div id="future-awards-row">
                <div className="award-column">
                  <div style={{fontWeight: "bold"}}>{t('FractionalSharesDialog.FutureAwards')}</div>
                </div>

                <div className="selected-election-container-future">
                  <div className="cash-refund-container-future">
                    <label htmlFor={"cash-refund"}>
                      {t('FractionalSharesDialog.HeaderCashRefund')}
                      <input className="cash-refund-radio-future"
                        type="radio"
                        name="election"
                        id="cash-refund"
                        value={false}
                        defaultChecked={employee.fractional_share_in !== true}
                        onChange={this.handleEmployeeRadioChange}
                      />
                    </label>
                  </div>
                  <div className="fractional-shares-container-future">
                    <label htmlFor={"frac-shares"}>
                      {t('FractionalSharesDialog.HeaderFractionalShares')}
                      <input className="fractional-shares-radio-future"
                        type="radio"
                        name="election"
                        id="frac-shares"
                        value={true}
                        defaultChecked={employee.fractional_share_in === true}
                        onChange={this.handleEmployeeRadioChange}
                      />
                    </label>
                  </div>
                </div>

                <div className="effective-election-container-future">
                </div>

              </div>
            </div>

            <p style={{marginBottom: "0px"}} dangerouslySetInnerHTML={{ __html: t('FractionalSharesDialog.VestDateSpecificElections')}}>
            </p>

            <div id="vest-rows">
              {
                this.state.vests.map((vest, index) => {
                  return <div key={index} className={"vest-row " + (!vest.fractional_share_eligible_in ? "disabled" : "")}>
                    <div className="award-info-container">
                      <div className="vest-date-container">
                        <div className="vest-date">{Moment(vest.vest_date).format('ll')}</div>
                        <div className="shares">{new Intl.NumberFormat(this.props.locale).format(vest.vest_shares)}&nbsp;{t('FractionalSharesDialog.SharesVesting')}</div>
                      </div>
                      <div className="award-id-container">
                        <div className="award-id">{vest.award_id}</div>
                        <div className="award-name">({vest.award_name})</div>
                      </div>
                    </div>

                    <div className="selected-election-container">
                      <div className="cash-refund-container">
                        <label htmlFor={"cash-refund" + index}>
                          {t('FractionalSharesDialog.HeaderCashRefund')}
                          <input
                            className="cash-refund-radio"
                            type="radio"
                            name={"election" + index}
                            id={"cash-refund" + index}
                            value={false}
                            data-index={index}
                            defaultChecked={vest.fractionalShareIndicator !== true}
                            checked={vest.fractionalShareIndicator !== true}
                            onChange={this.handleVestRadioChange}
                            disabled={!vest.fractional_share_eligible_in}
                            />
                        </label>
                      </div>
                      <div className="fractional-shares-container">
                        <label htmlFor={"frac-shares" + index}>
                          {t('FractionalSharesDialog.HeaderFractionalShares')}
                          <input
                            className="fractional-shares-radio"
                            type="radio"
                            name={"election" + index}
                            id={"frac-shares" + index}
                            value={true}
                            data-index={index}
                            defaultChecked={vest.fractionalShareIndicator === true}
                            checked={vest.fractionalShareIndicator === true}
                            onChange={this.handleVestRadioChange}
                            disabled={!vest.fractional_share_eligible_in}
                            />
                        </label>
                      </div>
                    </div>

                    <div className="effective-election-container">
                      <div>{this.getEffectiveElection(vest)}</div>
                    </div>
                  </div>
                })
              }
            </div>

            <p style={{marginBottom: "5px"}}>
              {t('FractionalSharesDialog.OnlyApply')}
            </p>

            <p style={{marginBottom: "0px", marginTop: "0px"}}>
              {t('FractionalSharesDialog.GreyedOut')}
            </p>
          </div>
        </Content>
        <Footer>
          <button className='primary-button save-election' onClick={this.buttonClickHandler}>{t('FractionalSharesDialog.Save')}</button>
        </Footer>
      </GenericModal>
    )
  }
}

const mapState = state => (
  {
    configuration: state.configuration,
    employee: state.employee,
    vests: employeeService.getUpcomingVests(state.employee.awards)
  }
)

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch),
    maintenance: bindActionCreators(maintenanceActions, dispatch),
  }
})

export default connect(mapState, mapDispatchToProps)((withTranslation('translations')(FractionalSharesDialog)))